
import { computed, defineComponent, onMounted, PropType, reactive, Ref } from 'vue'

import Loader from '@/common/components/UI/Loader/index.vue'
import NewButton from '@/ui-kit/NewButton/index.vue'
import NewModal from '@/common/new-components/NewModal/index.vue'
import ModalPanel from '@/modules/NewDispatcher/components/ModalPanel/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'
import NewSelect from '@/ui-kit/NewSelect/index.vue'
import NewInput from '@/ui-kit/NewInput/index.vue'
import NewCheckbox from '@/common/new-components/NewCheckbox/index.vue'

import tmsAPI from '@/new-services/tms.service'
import { DataState } from '@/core/classes/DataState.class'
import {
    ChildDirection,
    GetLogistDirectionItem,
    RescheduleTtnPayload,
    TripComment,
    TripRoute,
    TtnComment,
} from '@/new-services/types/tms'
import { ref } from 'vue'
import useNotifications from '@/common/composable/useNotifications'
import filtersGreyIcon from '@/assets/icons/filtersGrey.svg'
import { watch } from 'vue'
import { onBeforeUnmount } from 'vue'
import { InventoryInvoicesItem, ParentDirection } from '@/new-services/types/reports'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import PreTripDetails from '@/modules/TMSModule/components/PreTripDetails/index.vue'
import WorkplaceTimer from '@/modules/TMSModule/components/WorkplaceTimer/index.vue'
import { FTL } from '@/core/realisations/FTL.realisation'
import { orders } from '@/core/realisations/orders.realisation'

import { formatDateFromBackend, formatDateWithTimeFromBackend } from '@/common/helpers/formatDate'

type Column = {
    name: string
    key: string
}

export const FTLBidsStatusColors = {
    created: 'blue--outline',
    wait_cost_price: 'yellow--outline',
    on_updating: 'yellow',
    on_approval: 'orange--outline',
    carrier_data_entered: 'orange--fill',
    on_the_way: 'yellow',
    approved: 'yellow--fill',
    on_inspection_head_transport: 'yellow',
    completed: 'green--outline',
    confirmed: 'green',
    canceled: 'red--outline',
}

export default defineComponent({
    name: 'workplace-items',
    components: {
        Loader,
        NewButton,
        NewModal,
        PreTripDetails,
        ModalPanel,
        Cheap,
        NewSelect,
        NewInput,
        filtersGreyIcon,
        NewCheckbox,
        WorkplaceTimer,
    },
    props: {
        itemsLtl: {
            type: Object as PropType<any>,
            default: null,
        },
        itemsFtl: {
            type: Object as PropType<any>,
            default: null,
        },
        firstColumn: {
            type: Array as PropType<InventoryInvoicesItem[]>,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        failed: {
            type: Boolean,
            default: false,
        },
        type: {
            type: Array as PropType<String[]>,
            default: () => [],
        },
        columns: {
            type: Array as PropType<Column[]>,
            default: () => [],
        },
    },
    emits: ['refresh', 'scroll'],
    setup(props, { emit }) {
        const notifications = useNotifications()
        const filterRefs = ref<Record<string, HTMLElement | null>>({})

        const state = reactive({
            is_open: false,
            is_loading: false,
            //
            is_path_open: false,
            paths: new DataState<TripRoute>({}),
            //
            is_details_open: false,
            id: null as number | string | null,
            //
            fake_width: 2470,
            //
            opened_directions: [] as number[],
            direction_details: null as ParentDirection | null,
            child_direction_details: null as ChildDirection | null,
            direction_table: null as GetLogistDirectionItem | null,
            is_directions_loading: false,
            //
            is_comments: false,
            is_comments_loading: false,
            commentIdInbound: null as number | null,
            commentIdOutbound: null as number | null,
            comment_direction: null as any | null,
            //
            sortInvoiceHandledDate: 'desc' as 'desc' | 'asc',
            sortHandledDate: 'desc' as 'desc' | 'asc',
        })

        const ltl_delayed_modal = reactive({
            is_opened: false,
            is_loading: false,
            item: null as any | null,
            commentId: null as number | null,
        })

        const ltl_delayed_modal_form$ = useVuelidate(
            {
                commentId: { required },
            },
            ltl_delayed_modal
        )

        const update_popup = reactive({
            is_opened: false,
            is_loading: false,
            ttnId: null as number | null,
            tripId: null as number | null,
            expectedDate: null as string | null,
            newExpectedDate: null as string | null,
            commentId: null as number | null,
            commentInfo: null as string | null,
        })

        const update_popup_form$ = useVuelidate(
            {
                newExpectedDate: { required },
                commentId: { required }
            },
            update_popup
        )

        const filters_state = reactive({
            initialState: {
                is_open: false,
                //
                is_ftl: true,
                is_ltl: true,
                //
                is_delay: true,
                is_no_delay: true,
            },
            onReviewState: {
                is_open: false,
                //
                is_ftl: true,
                is_ltl: true,
                //
                is_delay: true,
                is_no_delay: true,
            },
            atSigningState: {
                is_open: false,
                //
                is_ftl: true,
                is_ltl: true,
                //
                is_delay: true,
                is_no_delay: true,
            },
            createdState: {
                is_open: false,
                //
                is_ftl: true,
                is_ltl: true,
                //
                is_delay: true,
                is_no_delay: true,
            },
            onTheWayState: {
                is_open: false,
                //
                is_ftl: true,
                is_ltl: true,
                //
                is_delay: true,
                is_no_delay: true,
            },
            delayedState: {
                is_open: false,
                //
                is_ftl: true,
                is_ltl: true,
                //
                is_delay: true,
                is_no_delay: true,
            },
            pbsOnReviewState: {
                is_open: false,
                //
                is_ftl: true,
                is_ltl: true,
                //
                is_delay: true,
                is_no_delay: true,
            },
            pbsAcceptedState: {
                is_open: false,
                //
                is_ftl: true,
                is_ltl: true,
                //
                is_delay: true,
                is_no_delay: true,
            },
        })

        const data_state = reactive({
            commentsOutbound: {
                is_loading: false,
                is_failed: false,
                list: [] as TripComment[],
            },
            commentsInbound: {
                is_loading: false,
                is_failed: false,
                list: [] as TripComment[],
            },
            general_comments: {
                is_loading: false,
                is_failed: false,
                list: [] as TripComment[],
            },
            ltl_comments: {
                is_loading: false,
                is_failed: false,
                list: [] as TripComment[],
            }
        })

        const loadGeneralComments = async () => {
            try {
                data_state.general_comments.is_loading = true

                const response = await tmsAPI.getTripComments()

                data_state.general_comments.list = response.data.data
                data_state.general_comments.is_failed = false
            } catch (error) {
                console.error(error)
                data_state.general_comments.is_failed = true
                notifications.notifyError({
                    error,
                    title: 'При получении списка комментариев произошла ошибка',
                })
            } finally {
                data_state.general_comments.is_loading = false
            }
        }

        const loadLtlComments = async () => {
            try {
                data_state.ltl_comments.is_loading = true

                const response = await tmsAPI.getTripComments(2)

                data_state.ltl_comments.list = response.data.data
                data_state.ltl_comments.is_failed = false
            } catch (error) {
                console.error(error)
                data_state.ltl_comments.is_failed = true
                notifications.notifyError({
                    error,
                    title: 'При получении списка комментариев произошла ошибка',
                })
            } finally {
                data_state.ltl_comments.is_loading = false
            }
        }

        const slot: Ref<HTMLElement | null> = ref(null)
        const slot_fake: Ref<HTMLElement | null> = ref(null)

        const onScroll = (e: any) => {
            if (slot_fake.value) {
                slot_fake.value.scrollLeft = e.target.scrollLeft
            }

            if (e.target.scrollTop !== 0) {
                emit('scroll')
            }
        }

        const onScrollFake = (e: any) => {
            if (slot.value) slot.value.scrollLeft = e.target.scrollLeft
        }

        const refresh = () => emit('refresh')

        const isInitialState = (key: string) => {
            return key === 'initialState'
        }
        const isReviewState = (key: string) => {
            return key === 'onReviewState'
        }
        const isSigningState = (key: string) => {
            return key === 'atSigningState'
        }
        const isCreatedState = (key: string) => {
            return key === 'createdState'
        }
        const isDelayedState = (key: string) => {
            return key === 'delayedState'
        }
        const isPbsReviewState = (key: string) => {
            return key === 'pbsOnReviewState'
        }
        const isPbsAcceptedState = (key: string) => {
            return key === 'pbsAcceptedState'
        }
        const isOnTheWayState = (key: string) => {
            return key === 'onTheWayState'
        }

        const getLink = (key: string, id: number, type = 'ltl') => {
            if (key === 'initialState') {
                if (type === 'ftl') return `/ftl/bids/${id}`
                return '/tms/graph'
            } else if (key === 'onReviewState') {
                if (type === 'ftl') return `/bids/${id}`
                return `/bids/new/${id}`
            } else if (key === 'atSigningState') {
                if (type === 'ftl') return `/bids/${id}`
                return `/bids/new/${id}`
            } else if (key === 'createdState') {
                if (type === 'ftl') return `/ftl-orders/${id}`
                return `/tms/trips/${id}`
            } else if (key === 'delayedState') {
                if (type === 'ftl') return `/ftl-orders/${id}`
                return `/tms/trips/${id}`
            } else if (key === 'onTheWayState') {
                if (type === 'ftl') return `/ftl-orders/${id}`
                return `/tms/trips/${id}`
            } else if (key === 'pbsOnReviewState' || key === 'pbsAcceptedState') {
                if (type === 'ftl') return `/rpp/${id}`
                return `/rpp/ltl/${id}`
            }

            return ''
        }

        const loadPath = async (id: number) => {
            try {
                state.paths.is_loading = true

                const response = await tmsAPI.getTripRoute(id)
                state.paths.list = response.data.data.ttnData.map((item) => {
                    return {
                        ...item,
                        isRed: item.isDelay === true,
                        isGreen: item.isDelay === false,
                    }
                })

                state.paths.is_failed = false
            } catch (error) {
                state.paths.is_failed = true
                console.error(error)
            } finally {
                state.paths.is_loading = false
            }
        }

        const togglePath = (id: number | null) => {
            state.is_path_open = !state.is_path_open
            
            if (state.is_path_open) {
                update_popup.tripId = id
                loadPath(id as number)
            }
        }

        const getName = (name: string, index: number) => {
            const hasPartTwo = name.includes('<br/>')

            const firstPart = name.split('<br/>')[0]
            const secondPart = name.split('<br/>')[1]

            if (index === 1) return firstPart
            else if (index === 2 && hasPartTwo) return secondPart

            return ''
        }

        const getValue = (value: string | number | null) => {
            if (value || value === 0) return value
            return '-'
        }

        const openDetails = (id: number | string) => {
            state.id = id
            state.is_details_open = true
        }

        const closeDetails = () => {
            state.is_details_open = false
            state.id = null
        }

        const getNoInfoImg = (column_key: string, type: string) => {
            if (column_key === 'initialState') {
                if (type === 'ltl') return 'initial_ltl.svg'
                return 'initial_ftl.svg'
            } else if (column_key === 'onReviewState') {
                return 'on_review.svg'
            } else if (column_key === 'atSigningState') {
                return 'at_signing.svg'
            } else if (column_key === 'createdState') {
                return 'created.svg'
            } else if (column_key === 'onTheWayState') {
                return 'on_the_way.svg'
            } else if (column_key === 'delayedState') {
                return 'completed.svg'
            } else if (column_key === 'pbsOnReviewState') {
                return 'pbs.svg'
            } else if (column_key === 'pbsAcceptedState') {
                return 'pbs_review.svg'
            }
        }

        const getNoInfoText = (column_key: string, type: string) => {
            if (column_key === 'initialState') {
                if (type === 'ltl') return 'График отправок не сформирован'
                return 'FTL заявки отсутствуют'
            } else if (column_key === 'onReviewState') {
                return 'Все заявки проверены'
            } else if (column_key === 'atSigningState') {
                return 'Все заявки подписаны'
            } else if (column_key === 'createdState') {
                return 'Сегодня рейсы еще не создавались'
            } else if (column_key === 'onTheWayState') {
                return 'Рейсы в пути не найдены'
            } else if (column_key === 'delayedState') {
                return 'Проблем по опозданиям нет'
            } else if (column_key === 'pbsOnReviewState') {
                return 'Все РПП проверены'
            } else if (column_key === 'pbsAcceptedState') {
                return 'Сегодня РПП еще не подтверждались'
            }
        }

        const isYesterday = (dateStr: string) => {
            const [day, month, year] = dateStr.split(' ')[0].split('.')
            const inputDate = new Date(Number(year), Number(month) - 1, Number(day))
            const yesterday = new Date()
            yesterday.setDate(yesterday.getDate() - 1)

            return (
                inputDate.getFullYear() === yesterday.getFullYear() &&
                inputDate.getMonth() === yesterday.getMonth() &&
                inputDate.getDate() === yesterday.getDate()
            )
        }

        const isToday = (dateStr: string) => {
            const [day, month, year] = dateStr.split(' ')[0].split('.')
            const inputDate = new Date(Number(year), Number(month) - 1, Number(day))
            const now = new Date()

            return (
                inputDate.getFullYear() === now.getFullYear() &&
                inputDate.getMonth() === now.getMonth() &&
                inputDate.getDate() === now.getDate()
            )
        }

        const getEmail = (email: string) => {
            const emailFirstPart = email.split('@')[0]

            if (emailFirstPart.length > 10) {
                const emailSecondPart = email.split('@')[1]
                const result = `${emailFirstPart.slice(0, 10)}...@${emailSecondPart}`
                return result
            }

            return email
        }

        const isRed = (item: any, keySearch: string) => {
            return (
                (isDelayedState(keySearch) && item.isDelayed) ||
                (item.isAboveCostStandard && !isPbsReviewState(keySearch)) ||
                item.isDelay ||
                (isCreatedState(keySearch) && !isToday(item.date) && !isYesterday(item.date))
            )
        }
        const isYellow = (item: any, keySearch: string) => {
            return isCreatedState(keySearch) && isYesterday(item.date)
        }
        const isBlue = (item: any, keySearch: string) => {
            return !isRed(item, keySearch) && !isYellow(item, keySearch)
        }

        const getFilterItem = (key: string) => {
            return filters_state[key as keyof typeof filters_state]
        }

        const getItems = (keySearch: string) => {
            let items: any[] = []
            const filterItem = getFilterItem(keySearch)

            // ПЕРВАЯ КОЛОНКА
            if (keySearch === 'initialState') {
                // FTL ПОКА НЕТ
                if (filterItem.is_ltl) {
                    for (const [key, value] of Object.entries(props.itemsLtl)) {
                        // @ts-ignore
                        if (keySearch === key)
                            // @ts-ignore
                            items = value.filter((item) => item.parentDirectionCount)
                    }
                }
                return items
            }

            if (filterItem.is_ltl) {
                for (const [key, value] of Object.entries(props.itemsLtl)) {
                    // @ts-ignore
                    if (keySearch === key) {
                        // @ts-ignore
                        const valueEdited = value.map((item) => {
                            return { ...item, type: 'ltl' }
                        })
                        // @ts-ignore
                        items = valueEdited
                    }
                }
            }
            if (filterItem.is_ftl) {
                for (const [key, value] of Object.entries(props.itemsFtl)) {
                    // @ts-ignore
                    if (keySearch === key) {
                        // @ts-ignore
                        const valueEdited = value.map((item) => {
                            return { ...item, type: 'ftl' }
                        })
                        // @ts-ignore
                        items = [...items, ...valueEdited]
                    }
                }
            }

            if (keySearch === 'onReviewState') {
                items.sort(
                    (a, b) =>
                        new Date(a.onReviewDate).getTime() - new Date(b.onReviewDate).getTime()
                )
                return items
            } else if (keySearch === 'atSigningState') {
                items.sort(
                    (a, b) =>
                        new Date(a.atSigningDate).getTime() - new Date(b.atSigningDate).getTime()
                )
                return items
            } else if (['createdState', 'onTheWayState', 'delayedState'].includes(keySearch)) {
                const itemsRed = items.filter((item) => isRed(item, keySearch))
                const itemsYellow = items.filter((item) => isYellow(item, keySearch))
                const itemsBlue = items.filter((item) => isBlue(item, keySearch))

                let itemsSorted: any[] = []

                if (filterItem.is_delay) {
                    itemsSorted = [...itemsRed]
                }
                if (filterItem.is_no_delay) {
                    itemsSorted = [...itemsSorted, ...itemsYellow, ...itemsBlue]
                }

                return itemsSorted
            } else if (keySearch === 'pbsOnReviewState') {
                items.sort(
                    (a, b) =>
                        new Date(a.onReviewDate).getTime() - new Date(b.onReviewDate).getTime()
                )
                return items
            } else if (keySearch === 'pbsAcceptedState') {
                items.sort(
                    (a, b) =>
                        new Date(a.acceptedDate).getTime() - new Date(b.acceptedDate).getTime()
                )
                return items
            }

            // items.sort(
            //     (a, b) => new Date(a.predictDate).getTime() - new Date(b.predictDate).getTime()
            // )
        }

        const toggleDirections = (index: number) => {
            const itemIndex = state.opened_directions.indexOf(index)
            if (itemIndex >= 0) {
                state.opened_directions.splice(itemIndex, 1)
            } else {
                state.opened_directions.push(index)
            }
        }

        const isDirectionOpen = (index: number) => {
            return state.opened_directions.includes(index)
        }

        // const sortDirections = (directions: ParentDirection[]) => {
        //     return directions.filter(
        //         (direction: ParentDirection) => direction.totalWeight && direction.totalCubature
        //     )
        // }

        const toggleHandledDate = () => {
            if (state.sortHandledDate === 'desc') {
                state.sortHandledDate = 'asc'
                loadDirection()
                return
            }

            state.sortHandledDate = 'desc'
            loadDirection()
        }

        const toggleInvoiceHandledDate = () => {
            if (state.sortInvoiceHandledDate === 'desc') {
                state.sortInvoiceHandledDate = 'asc'
                return
            }

            state.sortInvoiceHandledDate = 'desc'
        }

        const loadDirection = async (warehouseId?: number) => {
            if (!state.direction_details) return

            try {
                state.is_directions_loading = true

                const response = await tmsAPI.getLogistDirections(
                    state.direction_details.directionId,
                    {
                        sortBy: state.sortHandledDate,
                        invoiceSortBy: state.sortInvoiceHandledDate,
                        warehouseId: warehouseId as number,
                    }
                )
                state.direction_table = response.data.data
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При загрузке произошла ошибка',
                })
            } finally {
                state.is_directions_loading = false
            }
        }

        const openDirection = async (direction: ParentDirection, warehouseId: number) => {
            if (!direction) return
            state.direction_details = { ...direction }

            loadDirection(warehouseId)
        }

        const closeDirection = () => {
            state.direction_details = null
            state.child_direction_details = null
        }

        const closeChildDirection = () => (state.child_direction_details = null)

        const isCommentInbound = computed(() => {
            return state.comment_direction && state.comment_direction.isDelayedWhileInbound
        })
        const isCommentOutbound = computed(() => {
            return state.comment_direction && state.comment_direction.isDelayedWhileOutbound
        })

        const loadCommentsOutbound = async () => {
            try {
                data_state.commentsOutbound.is_loading = true

                const responseOutbound = await FTL.getComments(1)
                data_state.commentsOutbound.list = responseOutbound.data

                data_state.commentsOutbound.is_failed = false
            } catch (error) {
                data_state.commentsOutbound.is_failed = true
                console.error(error)
            } finally {
                data_state.commentsOutbound.is_loading = false
            }
        }

        const loadCommentsInbound = async () => {
            try {
                data_state.commentsInbound.is_loading = true

                const responseOutbound = await FTL.getComments(2)
                data_state.commentsInbound.list = responseOutbound.data

                data_state.commentsInbound.is_failed = false
            } catch (error) {
                data_state.commentsInbound.is_failed = true
                console.error(error)
            } finally {
                data_state.commentsInbound.is_loading = false
            }
        }

        const loadComments = () => {
            if (isCommentOutbound.value) loadCommentsOutbound()
            if (isCommentInbound.value) loadCommentsInbound()
        }

        const openLtlDelayedModal = (item: any) => {
            loadLtlComments()

            ltl_delayed_modal.item = { ...item }
            ltl_delayed_modal.is_opened = true
        }

        const closeLtlDelayedModal = () => {
            ltl_delayed_modal.is_opened = false
            ltl_delayed_modal.commentId = null
            ltl_delayed_modal_form$.value.$reset()
            ltl_delayed_modal.item = null
        }

        const submitLtlDelayedModal = async () => {
            ltl_delayed_modal_form$.value.$touch()
            if (ltl_delayed_modal_form$.value.$invalid) return

            try {
                ltl_delayed_modal.is_loading = true

                await tmsAPI.sendComment(ltl_delayed_modal.item.id, ltl_delayed_modal.commentId as number, 2)
                notifications.notify({ type: 'success', title: 'Причина опоздания сохранена' })
                
                closeLtlDelayedModal()
                emit('refresh')
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'При сохранении причины опоздания произошла ошибка' })
            } finally {
                ltl_delayed_modal.is_loading = false
            }
        }

        const toggleComments = (key?: string, item?: any) => {
            state.is_comments = !state.is_comments

            if (!key) {
                state.commentIdInbound = null
                state.commentIdOutbound = null
                state.comment_direction = null
                return
            }

            state.comment_direction = { ...item }

            loadComments()
        }

        const sendComment = async () => {
            if (
                (isCommentInbound.value && !state.commentIdInbound) ||
                (isCommentOutbound.value && !state.commentIdOutbound)
            ) {
                return
            }

            try {
                state.is_comments_loading = true

                if (isCommentOutbound.value && state.commentIdOutbound) {
                    await orders.setCommentFtlOrder(
                        state.comment_direction.id,
                        state.commentIdOutbound,
                        1
                    )
                }
                if (isCommentInbound.value && state.commentIdInbound) {
                    await orders.setCommentFtlOrder(
                        state.comment_direction.id,
                        state.commentIdInbound,
                        2
                    )
                }

                toggleComments()
                emit('refresh')
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При отправке произошла ошибка',
                })
            } finally {
                state.is_comments_loading = false
            }
        }

        const getCommentsTitle = computed(() => {
            return isCommentInbound.value
                ? 'Укажите причину опоздания FTL заказа'
                : 'Укажите причину задержки отгрузки FTL заказа'
        })

        const comment_state = reactive({
            is_open: false,
            is_loading: false,
            is_failed: false,
            list: [] as TtnComment[],
            id: null as number | null,
            commentId: null as number | null,
        })

        const comment_form$ = useVuelidate(
            {
                commentId: { required },
            },
            comment_state
        )

        const toggleCancel = (id?: number) => {
            comment_state.is_open = !comment_state.is_open
            if (comment_state.is_open) {
                comment_state.id = id || null
                loadComments()
            }
            comment_state.commentId = null
        }

        const setComment = async () => {
            comment_form$.value.$touch()
            if (comment_form$.value.$invalid || !comment_state.id) return

            try {
                comment_state.is_loading = true

                const payload = {
                    commentId: comment_state.commentId as number,
                }

                await tmsAPI.setComment(comment_state.id, payload)

                toggleCancel()
                emit('refresh')
                notifications.notify({ title: 'Комментарий добавлен', type: 'success' })
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При редактировании произошла ошибка',
                })
            } finally {
                comment_state.is_loading = false
            }
        }

        const isComments = computed(
            () => state.is_comments && (isCommentInbound.value || isCommentOutbound.value)
        )
        const isProject = (key: string) => {
            return (
                isReviewState(key) ||
                isSigningState(key) ||
                isCreatedState(key) ||
                isOnTheWayState(key) ||
                isDelayedState(key)
            )
        }

        const toggleFilters = (key: string) => {
            if (key in filters_state) {
                filters_state[key as keyof typeof filters_state].is_open =
                    !filters_state[key as keyof typeof filters_state].is_open
            } else {
                console.warn(`Unknown filter key: ${key}`)
            }
        }

        const resetFilters = (key: string) => {
            const filterItem = getFilterItem(key)

            if (!props.type.length) {
                filterItem.is_ftl = true
                filterItem.is_ltl = true
            }
            filterItem.is_delay = true
            filterItem.is_no_delay = true
        }

        const isFilterOpen = (key: string) => {
            if (key in filters_state) {
                return filters_state[key as keyof typeof filters_state].is_open
            }
            return false
        }

        const setFtl = (is_ftl: boolean) => {
            filters_state.initialState.is_ftl = is_ftl
            filters_state.onReviewState.is_ftl = is_ftl
            filters_state.atSigningState.is_ftl = is_ftl
            filters_state.createdState.is_ftl = is_ftl
            filters_state.onTheWayState.is_ftl = is_ftl
            filters_state.delayedState.is_ftl = is_ftl
            filters_state.pbsOnReviewState.is_ftl = is_ftl
            filters_state.pbsAcceptedState.is_ftl = is_ftl
        }

        const setLtl = (is_ltl: boolean) => {
            filters_state.initialState.is_ltl = is_ltl
            filters_state.onReviewState.is_ltl = is_ltl
            filters_state.atSigningState.is_ltl = is_ltl
            filters_state.createdState.is_ltl = is_ltl
            filters_state.onTheWayState.is_ltl = is_ltl
            filters_state.delayedState.is_ltl = is_ltl
            filters_state.pbsOnReviewState.is_ltl = is_ltl
            filters_state.pbsAcceptedState.is_ltl = is_ltl
        }

        const isRedDot = (key: string) => {
            const filterItem = getFilterItem(key)

            return (
                !filterItem.is_ftl ||
                !filterItem.is_ltl ||
                !filterItem.is_delay ||
                !filterItem.is_no_delay
            )
        }

        watch(
            () => props.type.length,
            () => {
                if (props.type.length) {
                    setFtl(props.type.includes('ftl'))
                    setLtl(props.type.includes('ltl'))
                } else {
                    setFtl(true)
                    setLtl(true)
                }
            }
        )

        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as HTMLElement

            for (const key of Object.keys(filterRefs.value)) {
                const refEl = filterRefs.value[key]
                const isOpen = isFilterOpen(key)

                if (isOpen && refEl && !refEl.contains(target)) {
                    toggleFilters(key)
                }
            }
        }

        const openChildDirection = (directionId: number) => {
            if (state.direction_table) {
                const childDirection = state.direction_table.directionInvoices.find(
                    (directionInvoice) => directionInvoice.directionId === directionId
                )

                if (childDirection) {
                    state.child_direction_details = { ...childDirection }
                }
            }
        }

        onMounted(() => {
            document.addEventListener('click', handleClickOutside)
        })

        onBeforeUnmount(() => {
            document.removeEventListener('click', handleClickOutside)
        })

        const getRef = (el: any, key: string) => {
            if (filterRefs.value) {
                filterRefs.value[key] = el
            }
        }

        const childDirectionInvoices = computed(() => {
            let arr = state.child_direction_details?.invoices ?? []

            const dir = state.sortInvoiceHandledDate === 'desc' ? -1 : 1

            return [...arr].sort((a, b) => {
                const dateA = a.cargoHandledDate
                    ? new Date(a.cargoHandledDate.replace(' ', 'T')).getTime()
                    : null
                const dateB = b.cargoHandledDate
                    ? new Date(b.cargoHandledDate.replace(' ', 'T')).getTime()
                    : null

                if (dateA === null && dateB === null) return 0
                if (dateA === null) return 1
                if (dateB === null) return -1

                return (dateA - dateB) * dir
            })
        })

        const onStartUpdateTtn = (payload: { id: number; expectedDate: string | null }) => {
            update_popup.ttnId = payload.id
            update_popup.expectedDate = payload.expectedDate
            update_popup.is_opened = true

            loadGeneralComments()
        }

        const onCancelUpdateTtn = () => {
            update_popup.is_opened = false
            update_popup.ttnId = null
            update_popup.tripId = null
            update_popup.expectedDate = null
            update_popup.newExpectedDate = null
            update_popup.commentId = null
            update_popup.commentInfo = null

            update_popup_form$.value.$reset()
        }

        const onSubmitUpdateTtn = async () => {
            update_popup_form$.value.$touch()
            if (update_popup_form$.value.$invalid) return

            if (!update_popup.tripId) return

            try {
                update_popup.is_loading = true

                const dateParts = (update_popup.newExpectedDate as string).split('T')
                const newExpectedDate = `${dateParts[0]} ${dateParts[1]}:00`

                const payload: RescheduleTtnPayload = {
                    ttnId: update_popup.ttnId as number,
                    expectedDate: update_popup.expectedDate,
                    newExpectedDate,
                    commentId: update_popup.commentId as number,
                    commentInfo: update_popup.commentInfo
                }

                await tmsAPI.rescheduleTtn(update_popup.tripId as number, payload)

                notifications.notify({ type: 'success', title: 'ТТН сохранена' })

                onCancelUpdateTtn()
                togglePath(null)

                emit('refresh')
            } catch (error) {
                notifications.notifyError({ error, title: 'При редактировании ТТН произошла ошибка' })
            } finally {
                update_popup.is_loading = false
            }
        }

        return {
            state,
            data_state,
            filters_state,
            ltl_delayed_modal,
            ltl_delayed_modal_form$,
            submitLtlDelayedModal,
            filterRefs,
            getItems,
            isRedDot,
            refresh,
            isInitialState,
            isReviewState,
            isSigningState,
            isCreatedState,
            isDelayedState,
            isPbsReviewState,
            isPbsAcceptedState,
            isOnTheWayState,
            getLink,
            togglePath,
            getName,
            getValue,
            openDetails,
            closeDetails,
            getNoInfoImg,
            getNoInfoText,
            //
            FTLBidsStatusColors,
            //
            slot_fake,
            slot,
            //
            onScroll,
            onScrollFake,
            isYesterday,
            isToday,
            getEmail,
            toggleDirections,
            isDirectionOpen,
            openDirection,
            closeDirection,
            closeChildDirection,
            openLtlDelayedModal,
            closeLtlDelayedModal,
            toggleComments,
            loadComments,
            sendComment,
            getCommentsTitle,
            isCommentInbound,
            isCommentOutbound,
            isComments,
            isProject,
            toggleFilters,
            isFilterOpen,
            getFilterItem,
            resetFilters,
            getRef,
            openChildDirection,
            //
            toggleHandledDate,
            toggleInvoiceHandledDate,
            childDirectionInvoices,
            comment_state,
            comment_form$,
            toggleCancel,
            setComment,
            formatDateFromBackend,
            formatDateWithTimeFromBackend,
            //
            loadGeneralComments,
            loadLtlComments,
            update_popup,
            update_popup_form$,
            onStartUpdateTtn,
            onCancelUpdateTtn,
            onSubmitUpdateTtn
        }
    },
})
